import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../../shared/loader'
import csvHelper from '../importCSVHelper';
import CryptoJS from 'crypto-js';
import common_helper from '../../../../common_helper'


import {
	Validator
} from 'vee-validate'
export default {
	name: 'importProducts',
	components: {
		Loader
	},
	data: function () {
		return {
			file: '',
			error_message: '',
			success_message: '',
			error_seen: false,
			success_seen: false,
			csv_config: [],

			rejectedList: [],
			isLoading: false,
			listDataCsv: [],
			csvFields: [],

			user_type: '',
			useremail: '',
			client: '',
			clientid: '',
			listClientData: [],
			showSelectClient: false,
			ClientErr: '',

			warehouseid: '',
			warehouse: '',
			merchant: '',
			listMerchantData: [],
			showMerchantFilter: false,
			showOtherDetails: true,
			Simplified_model: false
		}
	},
	created: function () { },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		this.client=window.localStorage.getItem('selectedClient')
		this.clientid=this.client;
		if(this.clientid!=='undefined'){
        	this.getMerchantData(this.clientid);
		}	
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.warehouseid = window.localStorage.getItem('selectedWarehouse');
				this.warehouse = this.warehouseid;
				// this.clientid = '';
				// this.getClientList();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				// this.clientid = '';
				// this.getClientList();
				break;

			case 'client_user':
				this.showMerchantFilter = false;
				this.clientid = userdetail.clientid ? userdetail.clientid :this.client;
				this.warehouseid = window.localStorage.getItem('selectedWarehouse');
				this.warehouse = this.warehouseid;
				this.getMerchantData(userdetail.clientid);
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		// async getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'checkClientIsMultiseller', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listClientData = result.data.data;
		// 		}
		// 	}
		// },
		// clientSelected() {
		// 	this.clientid = this.client;
		// 	this.showMerchantFilter = false;
		// 	this.showOtherDetails = true;
		// 	this.merchant = '';
		// 	this.getMerchantData(this.client);
		// },
		submitFile() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (!this.clientid) {
				this.ClientErr = this.$t('srReport.clientError');
				return false;
			}
			if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
				let uploadFileExtension = this.$refs.file.files[0];
				if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
					//do nothing
					console.log(uploadFileExtension.name, "=====================Valid Extension====================");
				} else {
					this.$alertify.error(this.$t('productLogReport.selectCSVFile'));
					return false;
					console.log(uploadFileExtension.name, "=====================InValid Extension====================");
				}
			}
			this.isLoading = true;
			if (document.getElementById('downloadBtn'))
				document.getElementById('downloadBtn').disabled = false;
			var formData = new FormData();
			formData.append('csv', this.file);
			formData.append('clientid', window.localStorage.getItem('selectedClient'));
			formData.append('useremail', this.useremail);
			formData.append('merchantid', this.merchant);

			axios.post(apiUrl.api_url + 'loadSalesOrderCSV',
				formData, {
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'Content-Type': 'multipart/form-data'
					//'Access-Control-Allow-Origin': '*'
				}
			})
				.then((response) => {
					this.file = ''
					document.getElementById('file').value = '';
					response = response.data.data[0];

					if (response.status == true) {
						this.success_seen = true;
						this.error_message = '';
						this.error_seen = false;
						this.csv_config = response.data.csv_config;
						this.success_message = response.data.total_items_created.length + " orders created successfully";

						if (response.data.total_items_rejected.length > 0) {
							this.error_message = response.data.total_items_rejected.length + " orders rejected";
							this.error_seen = true;
							this.rejectedList = response.data.total_items_rejected;
						}
					} else {
						this.error_seen = true;
						this.error_message = response.msg;
						this.success_message = '';
					}
					this.isLoading = false;
				})
				.catch(() => {
					this.error_seen = true;
					this.success_seen = false;
					this.error_message = this.$t('productLogReport.fileUploadErr');
					this.success_message = '';
					this.isLoading = false;
				});
		},
		downloadCSV() {
			document.getElementById('downloadBtn').disabled = true;
			this.isLoading = true;
			if (this.rejectedList.length > 0) {
				let csvFields = [];
				let csvArr = [];

				this.csv_config.forEach(function (field) {
					csvArr.push(field.db_col_name);
					let fieldname = field.csv_col_title;
					if(field.required === true && fieldname.indexOf("*") < 0){
						fieldname = fieldname + "*";
					}
					csvFields.push({
						'fieldIndex': field.csv_col_name,
						'fieldColumn': field.db_col_name,
						'fieldName': fieldname
					});
				});
				// Add last column for reason
				csvArr.push("failure_reason");
				csvFields.push({
					'fieldIndex': csvFields.length - 1,
					'fieldColumn': "failure_reason",
					'fieldName': "Failure Reason"
				})

				var dateFilder = [];
				var skipFilter = [];
				var csvResult = [];

				this.rejectedList.forEach(function (item) {
					var rowData = [];
					for (let i = 0; i < csvArr.length; i++) {
						if (item[csvArr[i]])
							rowData[csvArr[i]] = item[csvArr[i]]
						else
							rowData[csvArr[i]] = ''
					}
					csvResult.push(rowData);
				});

				csvHelper.data.jsonToCSV(this.$t('importCsv.orderFailure'), csvResult, csvFields, dateFilder, skipFilter);
				this.isLoading = false;
			}
		},
		Simplifiedfunc() {
			this.Simplified_model = document.getElementById("Simplified").checked
		},
		async downloadTemplate() {

			if(window.localStorage.getItem('selectedClient')==='undefined'){
				this.$alertify.error(this.$t('common.clientError'))
			}
			else{
			this.input = {
				'clientid': window.localStorage.getItem('selectedClient'),
				'type': 'sales_order'
			}

			if (this.Simplified_model == true) {
				this.input.isSimplifiedTemplate = true
			} else
				this.input.isSimplifiedTemplate = false

			let result = await common_helper.getRestApiResponse('POST', 'getCSVTemplate', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data.data[0].status) {
					let templateResult = [];
					result.data.data[0].data.forEach(function (field) {
						let fieldname = this.$t(`importCsv.${field.db_col_name}`);
						if(field.required === true && fieldname.indexOf("*") < 0){
							fieldname = fieldname + "*";
						}
						templateResult.push({
							'fieldIndex': field.csv_col_name,
							'fieldColumn': field.db_col_name,
							'fieldName': fieldname
						});
					},this);
					console.log(templateResult, "templateResult");
					if (this.Simplified_model == false) {

						csvHelper.data.jsonToCSV(this.$t('importCsv.orderTemplate'), [], templateResult, [], []);
					} else {
						csvHelper.data.jsonToCSV(this.$t('importCsv.simplifiedOrderTemplate'), [], templateResult, [], []);
					}
				} else {
					this.$alertify.error(result.data.data[0].msg);
					return false;
				}
			}
		}
		},

		resetFrom() {
			document.getElementById('file').value = '';
			this.error_seen = false;
			this.success_seen = false;
			this.rejectedList = [];
			this.file = ''
			this.showMerchantFilter = false;
			this.showOtherDetails = true;
			this.merchant = '';
			console.log(this.listMerchantData.length);
			if (this.user_type != 'client_user') {
				// this.client = '';
				// this.clientid = '';
			} else {
				if (this.listMerchantData.length > 0) {
					this.showMerchantFilter = true;
					this.showOtherDetails = false;
				}
			}
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},

		async getMerchantData(clientid) {
			this.isLoading = true
			this.input = ({
				clientid: clientid,
			});
			let resultMultiseller = await common_helper.getRestApiResponse('POST', 'checkClientIsMultiseller', this.input, this.$alertify)
			if (resultMultiseller && !resultMultiseller.errorDATA) {
				this.isLoading = false
				if (resultMultiseller && resultMultiseller.data.status == true) {
					this.showMerchantFilter = true
					this.showOtherDetails = false
					this.listMerchantData = [];
					this.input = ({
						clientid: clientid,
					});
					let result = await common_helper.getRestApiResponse('POST', 'merchantList', this.input, this.$alertify)
					if (result && !result.errorDATA) {
						this.listMerchantData = result.data
					}
					this.isLoading = false
				}
			}
		},

		merchantSelected() {
			if (this.merchant) {
				this.showOtherDetails = true
			} else {
				this.showOtherDetails = false
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/importCSV/importOrders/importOrders.component.js